/*
 * The campus, in the order the grid lays it out. `wide` takes two columns;
 * `tone` picks the card fill for the two rooms with no photograph, so the
 * grid does not fall into a run of identical white boxes.
 */
export const facilities = [
  {
    id: 'library',
    title: 'The library',
    body: '9,400 books, open from 7:30am, and a rule that any child may take any book home without asking permission.',
    photoCaption: 'Library or main hall photo',
    wide: true,
  },
  {
    id: 'labs',
    title: 'Two science labs',
    body: 'Gas, water and fume extraction. Grade 6 upward do experiments, not demonstrations.',
    photoCaption: 'Science lab photo',
  },
  {
    id: 'garden',
    title: 'Toddler garden',
    body: 'Shaded, soft-floored, fully fenced, with a water table and a vegetable bed the two-year-olds actually harvest.',
    photoCaption: 'Playground photo',
  },
  {
    id: 'workshop',
    title: 'The workshop',
    body: 'Woodwork benches, soldering irons and six computers. Secondary students build, break and fix real things.',
    tone: 'sun',
  },
  {
    id: 'field',
    title: 'Field & courts',
    body: 'Full-size football pitch, two netball courts, and a covered area for the rainy season.',
    photoCaption: 'Sports field photo',
  },
  {
    id: 'kitchen',
    title: 'Kitchen & clinic',
    body: 'A hot meal cooked on site every day, and a full-time nurse in a proper treatment room from 7:30 to 5.',
    tone: 'mint',
  },
];
